import { accountPaths, IApp } from '@todesktop/shared';

import { DeepPartial } from '../types';
import {
  getData,
  setData,
  updateOrCreateData,
  getCollection,
  deleteDocument,
  getSnapshot,
} from './common';
import { firestore } from './firestore';
import {
  doc,
  collection,
  collectionGroup,
  query,
  where,
  limit,
  getDocs,
  DocumentSnapshot,
  FirestoreError,
} from 'firebase/firestore';

export const getCustomDomains = (customDomain: string) =>
  getDocs(
    query(
      collectionGroup(firestore, 'applications'),
      where('customDomain', '==', customDomain),
      limit(1),
    ),
  );

export const getUserAppDoc = (id: string, appId: string) =>
  doc(firestore, accountPaths.application(id, appId));

export const getUserDeletedAppDoc = (id: string, appId: string) =>
  doc(firestore, accountPaths.deletedApplication(id, appId));

const getUserApplications = (id: string) =>
  collection(firestore, `${accountPaths.applications(id)}/`);

export const getUserApplicationData = (id: string, appId: string) =>
  getData<IApp>(getUserAppDoc(id, appId));

export const getUserApplicationsData = (id: string) =>
  getCollection<IApp>(getUserApplications(id));

export const saveUserApplicationData = (
  id: string,
  appId: string,
  application: IApp,
) => setData<IApp>(getUserAppDoc(id, appId), application);

export const updateUserApplicationData = (
  id: string,
  appId: string,
  application: DeepPartial<IApp>,
) => updateOrCreateData<IApp>(getUserAppDoc(id, appId), application);

export const deleteUserApplication = (id: string, appId: string) => {
  return deleteDocument(getUserAppDoc(id, appId));
};

export const onUserApplicationUpdate = (
  id: string,
  appId: string,
  handler: (arg: IApp, snapshot?: DocumentSnapshot) => void,
  onError?: (error: FirestoreError) => void,
) => {
  if (appId && id) {
    return getSnapshot<IApp>(getUserAppDoc(id, appId), handler, onError);
  }
};
